import React from 'react'

import * as Dialog from '@radix-ui/react-dialog'

import Button from '../../base/Button'
import useTranslation from '../../context/hooks/useTranslation'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import {
  selectMorningScanState,
  setReturnAcknowledgementModal,
} from '../../redux/MorningScan'
import CloseIcon from '../../vectors/CloseIcon'

export interface ReturnAcknowledgementDialogProps {
  onConfirm: () => Promise<void> | void
}

export const ReturnAcknowledgementDialog: React.FC<
  ReturnAcknowledgementDialogProps
> = ({ onConfirm }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const { showReturnAcknowledement } = useAppSelector(selectMorningScanState)

  const handleClose = () => {
    dispatch(setReturnAcknowledgementModal(false))
  }

  return (
    <Dialog.Root open={showReturnAcknowledement}>
      <Dialog.Portal>
        <Dialog.Overlay
          onClick={handleClose}
          className="bg-indigo-scrim fixed inset-0 opacity-60"
        />
        <Dialog.Content className="animate-fade-up shadow-elevation-2 fixed inset-0 m-auto h-fit w-fit max-w-[584px] rounded-md bg-white p-6">
          <Dialog.Close
            onClick={handleClose}
            className="hover:bg-gray-34 absolute right-4 top-4 outline-1 focus:outline-indigo-50"
          >
            <CloseIcon />
          </Dialog.Close>

          <Dialog.Title className="font-heading text-h3 mb-4">
            {t('RETURNS_SCAN.ACKNOWLEDGEMENT.TITLE')}
          </Dialog.Title>
          <Dialog.Description className="font-body text-md">
            {t('RETURNS_SCAN.ACKNOWLEDGEMENT.DESCRIPTION')}
          </Dialog.Description>

          <div className="mt-11 flex w-full flex-row justify-end gap-4">
            <Button primary onClick={onConfirm}>
              {t('RETURNS_SCAN.ACKNOWLEDGEMENT.CONFIRM')}
            </Button>
            <Button flat onClick={handleClose}>
              {t('RETURNS_SCAN.ACKNOWLEDGEMENT.BACK')}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export default ReturnAcknowledgementDialog
